import {Component, Input, SimpleChanges, OnChanges} from '@angular/core';
import {App} from 'ionic-angular';

@Component({
    selector: 'core-form-error',
    templateUrl: './form-error.component.html',
})
export class FormErrorComponent implements OnChanges {
    @Input() errors: Object;
    @Input() path: any;
    error: any = false;

    constructor(
        public app: App
    ) {

    }

    ngOnChanges(changes: SimpleChanges) {
        this.checkValues();
    }

    checkValues() {
        const keys = this.path.split('.');
        if (!this.errors || !this.path) {
            return;
        }
        if (this.hashKeyExists(this.errors, this.path)) {
            this.error = this.errors;
            for (let i = 0; i < keys.length; i++) {
                this.error = this.error[keys[i]];
            }
        } else {
            this.error = false;
        }
    }

    hashKeyExists(obj, path) {
        const keys = path.split('.');

        if (obj && typeof obj === 'object' && keys.length > 0) {
            return this.keyExists(obj, keys);
        } else {
            return false;
        }
    }

    keyExists(obj, keyList) {
        const cur = keyList.shift();

        if (obj.hasOwnProperty(cur)) {
            if (keyList.length <= 0) {
                return true;
            } else {
                return this.keyExists(obj[cur], keyList);
            }
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/form-error/form-error.component.ts